import React from 'react'
import PropTypes from "prop-types";
import { Client } from '../../client';
import ClearIcon from '../../components/icons/ClearIcon';
import IconButton from '../ui/IconButton';
import RubleIcon from '../icons/RubleIcon';
import RubleLightIcon from '../icons/RubleLightIcon';

const Rating = (q) => {
  const compeleted = [];

  for (var i = 0; i < 6; i++) {
    if (i + 1 <= q) {
      compeleted.push(true);
    } else {
      compeleted.push(false);
    }
  }

  return (
    compeleted.map((item, index) => (
      item ? <div key={index} className='b-fabric-info__rating-full' /> : <div key={index} />
    ))
  )
}

const ParmateresListItem = ({ value, propName }) => (
  <li className="b-fabric-info__params-list-item">
    <p>{propName}:</p>
    {['Прозрачность', 'Сминаемость'].indexOf(propName) > -1 ?
      <div className='b-fabric-info__rating'>
        {Rating(value)}
      </div>
      :
      <p>{value ? value : '-'}</p>
    }
  </li>
)


const ParametersList = ({ children }) => (
  <ul className="b-fabric-info__params-list">
    {children}
  </ul>
)

const ParamsWrapper = (fabric) => (
  <div className="b-fabric-info__params-wrapper">
    <ParametersList>
      <ParmateresListItem propName="Стиль" value={fabric.style} />
      <ParmateresListItem propName="Состав" value={fabric.composition} />
      <ParmateresListItem propName="Плотность" value={fabric.density} />
      <ParmateresListItem propName="Кручение нити" value={fabric.threadCount} />
      <ParmateresListItem propName="Вид плетения" value={fabric.weave} />
      <ParmateresListItem propName="Рисунок" value={fabric.color} />
      <ParmateresListItem propName="Обработка" value={fabric.treatment} />
      <ParmateresListItem propName="Сминаемость" value={fabric.resistance} />
      <ParmateresListItem propName="Прозрачность" value={fabric.opacity} />
    </ParametersList>
  </div>
)


const CommentImg = ({ src }) => (
  <div className='b-fabric-info__icon'>
    <img src={`/images/builder/${src}`} />
  </div>
)


const CommentImages = ({ children }) => {
  return (
    <div className='b-fabric-info__icon-set'>
      {children}
    </div>
  )
}

const ContentWrapper = ({ isMobile, onRequestClose, ...fabric }) => (
  <div className='b-fabric-info__content-wrapper'>
    <HeaderWrapper {...fabric} isMobile={isMobile} />
    <div className='b-fabric-info__text-wrapper'>
      <ParamsWrapper {...fabric} />
      <CommentWrapper {...fabric} />
    </div>
  </div>
)


const HeaderWrapper = ({ price, displayName, isMobile }) => (
  <div className="b-fabric-info__header-wrapper">
    <p className="b-fabric-info__header-name">{displayName}</p>
    <p className="b-fabric-info__header-price">
      {price}&#160;
      {isMobile ?
          <RubleLightIcon size={12} color='currentColor'/> :
          <RubleIcon size={17} color='currentColor'/>
      }
    </p>
  </div>
)

const CommentWrapper = ({ comment }) => {
  const spanRef = React.useRef(null);
  const [someHTML,] = React.useState(comment);

  React.useEffect(() => {
    if (spanRef.current) {
      spanRef.current.innerHTML = someHTML;
    }
  }, [spanRef.current, someHTML]);

  return <div className="b-fabric-info__comment-wrapper">
    <div ref={spanRef} />
    <CommentImages>
      <CommentImg src='wash_40.png' />
      <CommentImg src='iron_2.png' />
      <CommentImg src='dont_squeeze_and_dry.png' />
      <CommentImg src='dont_blench.png' />
      <CommentImg src='dclean.png' />
    </CommentImages>
  </div>
}


function ImagesCarousel({ article }) {
  const [index, setIndex] = React.useState(1);
  const [initialClientX, setInitialClientX] = React.useState(0);
  const [finalClientX, setfinalClientX] = React.useState(0);

  const handleClick = (action, e) => {
    e.preventDefault();
    let imageIndex = index;

    if (action === 'prev') {
      if (index === 1) {
        imageIndex = 5;
      } else {
        imageIndex--;
      }
    }
    if (action === 'next') {
      if (index === 5) {
        imageIndex = 1;
      } else {
        imageIndex++;
      }
    }
    setIndex(imageIndex);
  }

  const handleTouchStart = (e) => {
    setInitialClientX(e.nativeEvent.touches[0].clientX)
  }

  const handleTouchMove = (e) => {
    setfinalClientX(e.nativeEvent.touches[0].clientX)
  }

  const handleTouchEnd = (e) => {
    if (finalClientX < initialClientX) {
      handleClick('next', e);
    }

    if (finalClientX > initialClientX) {
      handleClick('prev', e);
    }

    setInitialClientX(0)
    setfinalClientX(0)
  }

  return (
    <div className="b-carousel">
      <img
        className="b-carousel__image"
        src={Client.getRemarkImageUrlForCarousel(article, index)}
        alt={`Preview image № ${index}`}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      />
      <button
        className="b-carousel__button b-carousel__button-prev"
        onClick={(e) => handleClick('prev', e)} />
      <button
        className="b-carousel__button b-carousel__button-next"
        onClick={(e) => handleClick('next', e)} />
      <div className="b-carousel__page-state">
        <ul>
          {[1, 2, 3, 4, 5].map(item => <li key={item} className={index === item ? 'current' : ''}></li>)}
        </ul>
      </div>
    </div>
  );
}

const FabricInfo = ({ isMobile, onRequestClose, ...fabric }) => {
  return (
    <div className="b-fabric-info">
      {isMobile &&
        <IconButton
          type='primary'
          size='small'
          className='b-fabric-info__close-button'
          onClick={onRequestClose}
          style={{ background: 'transparent', marginLeft: 'auto', fontSize: '24px' }}
        >
          <ClearIcon />
        </IconButton>
      }
      <ImagesCarousel {...fabric} />
      <ContentWrapper {...fabric} onRequestClose={onRequestClose} isMobile={isMobile} />
    </div>
  )
}

FabricInfo.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired, 
  article: PropTypes.string,
  price: PropTypes.any, 
  displayName: PropTypes.string, 
  comment: PropTypes.string,
  style: PropTypes.string,
  composition: PropTypes.string,
  density: PropTypes.number,
  threadCount: PropTypes.string,
  weave: PropTypes.string,
  color: PropTypes.string,
  treatment: PropTypes.string,
  resistance: PropTypes.number,
  opacity: PropTypes.number,
}

export default FabricInfo;